<div class="notifications-config-container">
  <div class="header">
    <!-- <h1>{{ title }} for {{ logsheetName ? " - " + logsheetName : "" }}</h1> -->
    <h1>
      Edit Notification for {{ logsheetName ? " - " + logsheetName : "" }}
    </h1>
    <p>Configure form Notifications</p>
  </div>
  <div class="content">
    <!-- Add your notification configuration content here -->
    <!-- <h2>Step 1</h2> -->
    <div class="custom-stepper">
      <div
        class="custom-stepper__step"
        [ngClass]="{
          active: activeStep === 1 && !isStep1Valid,
          completed: isStep1Valid
        }"
      >
        <div class="custom-stepper_status_container">
          <span>STEP 1</span> <small>Types & Channels</small>
        </div>

        <div>
          <img
            [src]="
              isStep1Valid
                ? '../../../assets/check-mark.svg'
                : '../../../assets/important-icon.svg'
            "
            alt="icon"
            style="width: 20px; height: 20px"
          />
        </div>
      </div>
      <div
        class="custom-stepper__step"
        [ngClass]="{
          active: activeStep === 2 && !isStep2Valid,
          completed: isStep2Valid,
          'disabled-stepper': !isStep1Valid
        }"
      >
        <div class="custom-stepper_status_container">
          <span>STEP 2</span>
          <small>Recipient Information</small>
        </div>

        <div *ngIf="activeStep === 2">
          <img
            [src]="
              isStep2Valid
                ? '../../../assets/check-mark.svg'
                : '../../../assets/important-icon.svg'
            "
            alt="icon"
            style="width: 20px; height: 20px"
          />
        </div>
      </div>
    </div>

    <!-- STEP 1 -->
    <div *ngIf="activeStep == 1" class="custom-stepper__step1">
      <h4>What notification do you want to send?</h4>
      <label>Select Notification Channel(s)</label>
      <!-- <div class="notification-channels">
        <label class="channel-option">
          <input
            type="checkbox"
            id="sms"
            name="sms"
            (change)="onSmsChange($event)"
            [checked]="smsSelected"
          />
          <span>SMS Notifications</span>
        </label>
      </div> -->

      <app-notification-type-card
        title="Per Item Notification"
        description="Send notifications for each individual item update"
        [enabled]="perItemEnabled"
        [channels]="perItemChannels"
        (enabledChange)="onNotificationTypeToggle('perItem', $event)"
        (channelsChange)="onNotificationTypeChannelsChange('perItem', $event)"
      ></app-notification-type-card>

      <app-notification-type-card
        title="Form Submission Notification"
        description="Notify when a form is completed and submitted"
        [enabled]="formSubmissionEnabled"
        [channels]="formSubmissionChannels"
        (enabledChange)="onNotificationTypeToggle('formSubmission', $event)"
        (channelsChange)="
          onNotificationTypeChannelsChange('formSubmission', $event)
        "
      ></app-notification-type-card>

      <!-- Reminder Notification -->
      <app-notification-type-card
        title="Reminder Notification"
        description="Schedule reminder notifications for upcoming tasks"
        [enabled]="reminderEnabled"
        [channels]="reminderChannels"
        (enabledChange)="onNotificationTypeToggle('reminder', $event)"
        (channelsChange)="onNotificationTypeChannelsChange('reminder', $event)"
      ></app-notification-type-card>
    </div>

    <!-- STEP 2 -->
    <div *ngIf="activeStep == 2" class="custom-stepper__step2">
      <app-recipient-card
        *ngIf="perItemEnabled"
        cardId="per-item-recipients"
        [title]="'Who should receive the Per Item Notification?'"
        [subtitle]="'Choose how you want to specify recipients'"
        [expanded]="recipientCards.perItem.expanded"
        [appUserSelected]="recipientCards.perItem.appUserSelected"
        [uploadedRefFileSelected]="recipientCards.perItem.uploadedRefFileSelected"
        [users]="dbUsers"
        [selectedUsers]="recipientCards.perItem.selectedUsers"
        [uploadedFileName]="recipientCards.perItem.uploadedFileName"
        [uploadProgress]="recipientCards.perItem.uploadProgress"
        [uploadStatus]="recipientCards.perItem.uploadStatus"
        [showUploadStatus]="recipientCards.perItem.showUploadStatus"
        [csvValidated]="recipientCards.perItem.csvValidated"
        [validationMessage]="recipientCards.perItem.validationMessage"
        (toggleExpanded)="toggleCard('perItem')"
        (appUserToggle)="toggleAppUser('perItem')"
        (refFileToggle)="toggleUploadedRefFile('perItem')"
        (selectionChange)="onRecipientsChanged($event, 'perItem')"
        (fileSelected)="onFileSelected($event, 'perItem')"
        (downloadSample)="downloadCsvTemplate('perItem')"
      ></app-recipient-card>

      <app-recipient-card
        *ngIf="formSubmissionEnabled"
        cardId="form-submission-recipients"
        [title]="'Who should receive the Form Submission Notification?'"
        [subtitle]="'Choose how you want to specify recipients'"
        [expanded]="recipientCards.formSubmission.expanded"
        [appUserSelected]="recipientCards.formSubmission.appUserSelected"
        [uploadedRefFileSelected]="recipientCards.formSubmission.uploadedRefFileSelected"
        [users]="dbUsers"
        [selectedUsers]="recipientCards.formSubmission.selectedUsers"
        [uploadedFileName]="recipientCards.formSubmission.uploadedFileName"
        [uploadProgress]="recipientCards.formSubmission.uploadProgress"
        [uploadStatus]="recipientCards.formSubmission.uploadStatus"
        [showUploadStatus]="recipientCards.formSubmission.showUploadStatus"
        [csvValidated]="recipientCards.formSubmission.csvValidated"
        [validationMessage]="recipientCards.formSubmission.validationMessage"
        (toggleExpanded)="toggleCard('formSubmission')"
        (appUserToggle)="toggleAppUser('formSubmission')"
        (refFileToggle)="toggleUploadedRefFile('formSubmission')"
        (selectionChange)="onRecipientsChanged($event, 'formSubmission')"
        (fileSelected)="onFileSelected($event, 'formSubmission')"
        (downloadSample)="downloadCsvTemplate('formSubmission')"
      ></app-recipient-card>

      <app-recipient-card
        *ngIf="reminderEnabled"
        cardId="reminder-recipients"
        [title]="'Who should receive the Reminder Notification?'"
        [subtitle]="'Choose how you want to specify recipients'"
        [expanded]="recipientCards.reminder.expanded"
        [appUserSelected]="recipientCards.reminder.appUserSelected"
        [uploadedRefFileSelected]="recipientCards.reminder.uploadedRefFileSelected"
        [users]="dbUsers"
        [selectedUsers]="recipientCards.reminder.selectedUsers"
        [uploadedFileName]="recipientCards.reminder.uploadedFileName"
        [uploadProgress]="recipientCards.reminder.uploadProgress"
        [uploadStatus]="recipientCards.reminder.uploadStatus"
        [showUploadStatus]="recipientCards.reminder.showUploadStatus"
        [csvValidated]="recipientCards.reminder.csvValidated"
        [validationMessage]="recipientCards.reminder.validationMessage"
        (toggleExpanded)="toggleCard('reminder')"
        (appUserToggle)="toggleAppUser('reminder')"
        (refFileToggle)="toggleUploadedRefFile('reminder')"
        (selectionChange)="onRecipientsChanged($event, 'reminder')"
        (fileSelected)="onFileSelected($event, 'reminder')"
        (downloadSample)="downloadCsvTemplate('reminder')"
      ></app-recipient-card>
    </div>

    <div class="nc-buttons">
      <!-- Cancel Button - Always shown -->
      <button type="button" class="btn-outline" (click)="transferData()">
        Cancel
      </button>

      <!-- Back Button - Shown on steps 2 and 3 -->
      <button
        *ngIf="activeStep > 1"
        type="button"
        class="btn-outline"
        (click)="setActiveStep(activeStep - 1)"
      >
        Back
      </button>

      <!-- Next/Finish Button -->
      <button
        [ngClass]="!enableNextBtn() ? 'disabled-btn' : ''"
        [disabled]="!enableNextBtn()"
        (click)="activeStep == 1 ? setActiveStep(2) : onSaveClick()"
        type="submit"
        class="nc-next-btn"
      >
        {{ activeStep == 2 ? "Save & Exit" : "Next" }}
      </button>
    </div>

    <!-- Save Confirmation Modal -->
    <app-save-modal
      (onSave)="handleSaveConfirm()"
      (closeModal)="handleSaveCancel()"
      *ngIf="showSaveModal"
      [actionButtonTitle]="'Save'"
      [subTitle]="'If you do not save, your changes will be lost.'"
      [title]="'Are you sure you want to save changes?'"
    >
    </app-save-modal>

    <!-- Success/Error Toast -->
    <app-success-toast *ngIf="toastService.showToast"></app-success-toast>
  </div>
</div>
